import React from "react";
import { RecommendationInfo } from "src/model/Recommendation";
import MetricsUtil from "src/utils/MetricsUtil";
import { withTranslation, WithTranslation } from "react-i18next";
import { KatAlert, KatLabel, KatLink } from "@amzn/katal-react";
import {getCurrencyUnitConfig, RECOMMENDATION_FBA} from "src/config/Config";
import FormatUtil from "src/utils/FormatUtil";

interface OwnProps {
    readonly metricsUtil?: MetricsUtil,
    readonly countryCode: string,
    readonly recommendationInfo: RecommendationInfo,
    readonly handleRecommendationDismiss: Function,
}

type Props = OwnProps & WithTranslation;

interface State {
}

export class ProgramRecommendationComponent extends React.Component<Props, State> {
    private readonly metricsUtil: MetricsUtil;

    constructor(props: Props) {
        super(props);

        if (this.props.metricsUtil) {
            this.metricsUtil = this.props.metricsUtil;
        } else {
            this.metricsUtil = MetricsUtil.getDefaultMetricUtil();
        }
    }

    handleDismiss(recommendation: string): (event: KatAlert.DismissEvent) => void {
        return (event: KatAlert.DismissEvent) => {
            if (this.metricsUtil) {
                this.metricsUtil.publishCounter('programRecommendation:' + recommendation, 'dismissed');
            }
            this.props.handleRecommendationDismiss();
        };
    }

    produceProgramRecommendation() {
        const {t, countryCode, recommendationInfo} = this.props;
        const attributes = recommendationInfo.attributes;
        const benefit = FormatUtil.formatCurrency(getCurrencyUnitConfig(countryCode), Number(attributes['GMS_LIFT_PERCENT_30']));
        return (
            <div>
                <KatAlert variant="info" onDismiss={this.handleDismiss('FBA')}
                          header={t('SC_FBA_Calc_info_fbaRecommendationBenefit', {
                              X: `${benefit}`})}>
                    <KatLabel text={t('SC_FBA_Calc_info_fbaRecommendation')}/>
                </KatAlert>
            </div>
        );
    }

    render() {
        const {recommendationInfo} = this.props;

        if (recommendationInfo.communicationType === RECOMMENDATION_FBA) {
            return this.produceProgramRecommendation();
        } else {
            return (<></>);
        }
    }
}

export default withTranslation()(ProgramRecommendationComponent);
